import React from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({
  text,
  location = 'top',
  className = '',
  style = {},
  children
}) => {
  return text && text.length && text.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style,
    "data-tooltip": text,
    "data-tooltip-location": location
  }, children) : children;
};

Tooltip.propTypes = {
  text: PropTypes.any.isRequired,
  location: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
  className: PropTypes.string,
  style: PropTypes.object
};
export default Tooltip;